module.exports = __webpack_public_path__ + "static/media/sagequantum.83b2aa43.png";